export default __webpack_public_path__ + "static/sviluppo-low-code-trasformazione-digitale-d2d0386ffbb9256afe62c5974b3ed92c.jpg";